// extracted by mini-css-extract-plugin
module.exports = {"button":"styles__button___2_piq"};